import React from 'react';
import { fetchAllExperiments, updateExperimentStatus, bulkUpdateExperimentStatus, deleteExperimentPermanently, fetchModerationStats } from '../../services/moderationService';
import SubmissionManager from './SubmissionManager';

function ManageEntries() {
    return (
        <SubmissionManager
            title="Manage Entries"
            subtitle="View and control status of all submissions."
            fetchData={fetchAllExperiments}
            fetchStats={fetchModerationStats}
            onAction={updateExperimentStatus}
            onBulkAction={bulkUpdateExperimentStatus}
            onDelete={deleteExperimentPermanently}
            allowStatusFilter={true}
            allowBulkActions={true}
            allowDelete={true}
            allowedActions={['APPROVED', 'REJECTED', 'PENDING', 'NEEDS_UPDATE']}
        />
    );
}

export default ManageEntries;
